import { useQueryClient } from '@tanstack/react-query'

import { GET_FEED_UNREAD_COUNT_QUERY_KEY } from '../api/feed.service'
import { UnreadActivitiesCountList } from '../domain/userInteraction'

export const useUpdateUnreadCountQueries = () => {
  const queryClient = useQueryClient()

  const updateUnreadCountQueries = async (entityID: string, activityID: string) => {
    await queryClient
      .getQueryCache()
      .findAll({ predicate: (q) => q.queryKey[0] === GET_FEED_UNREAD_COUNT_QUERY_KEY })
      .forEach((q) => {
        queryClient.setQueryData<UnreadActivitiesCountList | undefined>(q.queryKey, (prev) => ({
          ...prev,
          [entityID]: {
            entityID,
            unreadCount: 0,
            activityID,
          },
        }))
      })
  }

  return updateUnreadCountQueries
}
